{
  "Einheitsversicherung": "#AF9A6F",
  "Wohngebaeude": "#1D6FA4",
  "Feuer": "#E61B00",
  "Flusskasko": "#00857A",
  "Haftpflicht": "#7FBA00",
  "industrie": "#100BEF",
  "kfz": "#AA00E6",
  "Luftfahrt": "#0041AC",
  "missing": "#FFFFFF",
  "Rahmen_und_Sammelvertraege_Multi-Line": "#6E7191",
  "Sach": "#610BEF",
  "Seekasko": "#005BD4",
  "Sonstige_Versicherung": "#007A70",
  "Sportbootkasko": "#EAAC30",
  "Technische": "#EE6D00",
  "Technische_Betriebsunterbrechung": "#6E7191",
  "Transport": "#E3026F",
  "Verkehr": "#008A00"
}
